exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mr-icon {\n  display: inline-block;\n  color: inherit;\n  vertical-align: middle;\n  fill: none;\n  stroke: currentColor;\n}\n.mr-icon.default-size {\n  width: 1em;\n}\n.mr-icon-fill {\n  fill: currentColor;\n  stroke: none;\n}\n", ""]);

// exports
